<template>
    <footer class="footer-container bg-primary">
      <div class="footer-content">
        <!-- Kiri: Logo & Tagline -->
        <div class="footer-left">
          <img src="@/assets/hobi-baca-trans.png" alt="HobiBaca Logo" class="footer-logo" />
          <p class="footer-tagline">Membaca lebih mudah & menyenangkan</p>
        </div>
  
        <!-- Tengah: Menu Utama -->
        <div class="footer-middle">
          <ul>
            <li><router-link to="/langganan">Langganan</router-link></li>
            <li><router-link to="/categories-all">Kategori</router-link></li>
            <li><router-link to="/affiliates">Afiliasi</router-link></li>
          </ul>
        </div>
  
        <!-- Kanan: Informasi -->
        <div class="footer-right">
          <ul>
            <li><router-link to="/tentang-hobibaca">Tentang Kami</router-link></li>
            <li><router-link to="/ketentuan-layanan-hobibaca">Ketentuan Layanan</router-link></li>
            <li><router-link to="/kebijakan-pengembalian-dana">Kebijakan Pengembalian Dana</router-link></li>
            <li><router-link to="/privacy">Kebijakan Privasi</router-link></li>
            <li><router-link to="/help">Bantuan</router-link></li>
            <li><router-link to="/contact">Kontak Kami</router-link></li>
          </ul>
        </div>
      </div>
  
      <div class="footer-bottom">
        <p>&copy; 2025 HobiBaca. Semua Hak Dilindungi.</p>
      </div>
    </footer>
  </template>
  
  <style scoped>
  .footer-container {
    padding: 30px 20px;
    text-align: center;
  }
  
  .footer-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start; /* Ensures all content is aligned properly */
    max-width: 1100px;
    margin: 0 auto;
    color: slategray;
  }
  
  .footer-left {
    text-align: left;
    flex: 1;
  }
  
  .footer-middle {
    text-align: left;
    flex: 1;
  }
  
  .footer-right {
    text-align: left;
    flex: 1;
  }
  
  .footer-logo {
    width: 90px;
    margin-bottom: 10px;
  }
  
  .footer-tagline {
    font-size: 14px;
    opacity: 0.8;
  }
  
  ul {
    list-style: none;
    padding: 0;
    text-align: left;
  }
  
  li {
    margin: 5px 0;
    font-size: 14px;
  }
  
  a {
    text-decoration: none; /* ✅ Remove underline */
    color: inherit;
    transition: color 0.3s;
  }
  
  a:hover {
    color: darkslategray;
  }
  
  .footer-bottom {
    border-top: 1px solid slategray;
    padding-top: 15px;
    font-size: 14px;
    opacity: 0.7;
    color: slategray;
  }
  </style>
  